export default __webpack_public_path__ + "static/media/montana.d82e9a5b.jpg";